// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__39t7o","col":"styles_col__joo2z"};